import React from 'react';

import * as OrganizationActions from 'actions/OrganizationActions';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {BenchlingApp, User} from 'constants/UserConstants';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {EntityWithText} from 'ui-library/entity-input/EntityInputConstants';
import {SingleEntityInput} from 'ui-library/entity-input/SingleEntityInput';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';

import {Member} from './OrganizationConstants';

export interface AddTeamMemberInputProps {
  type: ModelTypeConstants.BENCHLING_APP | ModelTypeConstants.USER;
  organizationId: string;
  team: {id: string};
  existingMembers?: Array<Member>;
}

export default function AddTeamMemberInput({
  team,
  existingMembers,
  organizationId,
  type,
}: AddTeamMemberInputProps): JSX.Element {
  function handleAddTeamMember({entity}: {entity?: User | BenchlingApp}): void {
    if (!entity) {
      return;
    }
    OrganizationActions.addTeamMember(team.id, entity);
  }

  function filterExistingMembersAndIncorrectType(
    text: string,
    options: Array<EntityWithText>
  ): Array<EntityWithText> {
    if (!existingMembers) {
      return options;
    }
    options = options.filter((o) => (o.type as string) === (type as string));
    const existingMemberIds = existingMembers.map((m) => m.id);
    return options.filter((o) => !existingMemberIds.includes(o.id));
  }

  return (
    <SingleEntityInput
      addKeys={[13]}
      allowEmails={false}
      allowTeams={false}
      allowOrganizations={false}
      size={TagsInputSize.SMALL}
      allowBenchlingApps={type === ModelTypeConstants.BENCHLING_APP}
      buttonProps={{
        buttonStyle: ButtonStyle.SECONDARY,
        size: ButtonSize.SMALL,
        text: type === ModelTypeConstants.BENCHLING_APP ? 'Add App' : 'Add Member',
      }}
      filterOptions={filterExistingMembersAndIncorrectType}
      onSubmit={handleAddTeamMember}
      organizationIds={[organizationId]}
      placeholder={type === ModelTypeConstants.BENCHLING_APP ? 'Search for an app' : 'Search for a user'}
    />
  );
}
